import * as CONSTRUCTOR from '../generate';

export const showroomMediaPresignedResponse = CONSTRUCTOR.FRAGMENT({
  name: 'ShowroomMediaPresignedResponse',
  fragmentName: 'ShowroomMediaPresignedResponseFields',
  fields: `{
    mediaId
    presignedUrl
    expiresAt
  }`,
});

export const showroomMediaConfirmResponse = CONSTRUCTOR.FRAGMENT({
  name: 'ShowroomMediaConfirmResponse',
  fragmentName: 'ShowroomMediaConfirmResponseFields',
  fields: `{
    mediaId
    status
  }`,
});

export const showroomMediaUrlResponse = CONSTRUCTOR.FRAGMENT({
  name: 'ShowroomMediaUrlResponse',
  fragmentName: 'ShowroomMediaUrlResponseFields',
  fields: `{
    presignedUrl
    expiresAt
  }`,
});
